import React from 'react';
import { useLingui } from '@lingui/react';
import { Text, Skeleton, Flex } from '@landr/maestro';
import { defaultRowContainer } from '../SamplesTablePlayer/SamplesTablePlayer.styled';
import { SamplesTableKeyProps } from './SamplesTableKey.types';

export const SamplesTableKeySkeleton = () => (
    <Flex className={defaultRowContainer}>
        <Flex width="sm">
            <Skeleton width="xs" height="xs" />
        </Flex>
    </Flex>
);

export const SamplesTableKey: React.FC<SamplesTableKeyProps> = ({
    keyCode,
}) => {
    const { i18n } = useLingui();

    return (
        <Text textStyle="body-sm" color="text.medium">
            {keyCode && i18n._(keyCode)}
        </Text>
    );
};
